import React from 'react';

interface Props {
	children: React.ReactNode;
	marginTop?: string;
	marginBottom?: string;
}

export function Group(props: Props) {
	const { children, marginTop = 0, marginBottom = 0 } = props;

	return (
		<div
			style={{
				marginTop,
				marginBottom,
			}}
		>
			{children}
		</div>
	);
}
